module.exports = __webpack_public_path__ + "images/help/guide_video_pay-14034f2ce537600fa1199633d1d7ecb3.png";